import { t as globalT } from "@lingui/core/macro";
import { createFileRoute } from "@tanstack/react-router";

import {
  TransactionsTable,
  transactionsQuerySchema,
} from "@/components/TransactionsTable.tsx";

export const Route = createFileRoute("/transactions/")({
  component: RouteComponent,
  validateSearch: transactionsQuerySchema,
  head: () => ({
    meta: [
      {
        title: globalT`Sweco REALity` + " - " + globalT`Transactions`,
      },
    ],
  }),
});

function RouteComponent() {
  return <TransactionsTable route={Route.id} />;
}
